import { render, staticRenderFns } from "./manage_record.vue?vue&type=template&id=5f38d01e&"
import script from "./manage_record.vue?vue&type=script&lang=ts&"
export * from "./manage_record.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports